<template>
    <div class="projectSheet">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm" label-width="100px">
                    <el-row>
<!--                        <el-col :span="6">-->
<!--                            <el-form-item label="分项合同编号：">-->
<!--                                <el-input v-model="dataForm.serialNumber" placeholder="请输入分项合同编号" clearable></el-input>-->
<!--                            </el-form-item>-->
<!--                        </el-col>-->
                        <el-col :span="6">
                            <el-form-item label="所属项目：">
                                <el-select v-model="dataForm.projectId" style="width: 100%;" placeholder="请选择所属项目" filterable @change="getSubInfoByProjectIdList">
                                    <el-option :label="allProjectItem.name" :value="allProjectItem.id" v-for="(allProjectItem,allProjectIndex) in allProjectList" :key="'allProject'+allProjectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="合作单位：">
                                <el-select v-model="dataForm.partyBId" placeholder="请选择合作单位" filterable>
                                    <el-option :label="subInfoItem.partyB" :value="subInfoItem.partyBId" v-for="(subInfoItem,subInfoIndex) in subInfoList" :key="'subInfoItem'+subInfoIndex" ></el-option>
                                </el-select>
<!--                                <el-input v-model="dataForm.partyB" placeholder="请输入合作单位" clearable></el-input>-->
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button type="info" @click="reset()">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <!--                                    v-if="btnAuthorize.export.btnEnable"-->
                            <el-button
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportBtn()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                    ref="dataTable"
                    :data="engineerList"
                    :span-method="spanArrayMethod"
                    highlight-current-row
                    size="mini"
                    height="100%"
                    border>
                    <el-table-column label="细目号" prop="subCategoryNo" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="细目名称" prop="subCategoryName" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="单位" prop="unit" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="合同数量" prop="quantitySubContract" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="事中成本表中数量" prop="quantityMiddle" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="单价" prop="unitPrice" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="金额" prop="unitSumPrice" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column label="备注" prop="remarks" :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </el-main>
<!--            <el-footer>-->
<!--                <el-pagination-->
<!--                        @size-change="handleSizeChange"-->
<!--                        @current-change="handleCurrentChange"-->
<!--                        :current-page="dataForm.pageIndex"-->
<!--                        :page-sizes="[10, 20, 30, 50, 100]"-->
<!--                        :page-size="dataForm.pageSize"-->
<!--                        layout="total, prev, pager, next, sizes, jumper"-->
<!--                        :total="total"-->
<!--                ></el-pagination>-->
<!--            </el-footer>-->
        </el-container>
    </div>
</template>

<script>
    import {
        getAllProjectPassListService,
        projectSettleExportService,
        getProjectSettleService,
    } from "../../services/engineering";
    import {exportExcelService2} from "../../services/allContractServices";
    import {
        getSubInfoByProjectId,
    } from "@/services/financeService";
    import {getTableData} from "./spanMethod";

    export default {
        name: "projectSheet",
        data(){
            return {
                dataForm:{
                    partyBId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                },
                engineerList: [],
                total: 0,

                allProjectList: [],
                subInfoList: [],
            }
        },
        methods: {
            onActive(menuCode) {
                // this.$getRoleBtns(menuCode, this.btnAuthorize);
                // this.query();
                this.getAllProjectPassListService();
            },
            getAllProjectPassListService() {
                getAllProjectPassListService().then( res => {
                    if(res.code == 10000000){
                        this.allProjectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            getSubInfoByProjectIdList() {
                let params = {
                    projectId: this.dataForm.projectId
                }
                getSubInfoByProjectId(params).then( res => {
                    if(res.code == 10000000){
                        this.dataForm.partyBId = '';
                        this.subInfoList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            query(){
                if(!this.dataForm.projectId){
                  this.$message.error('请选择所属项目！');
                  return
                }
                let paramsData = {
                    ...this.dataForm
                }
                getProjectSettleService(paramsData).then( res => {
                    if(res.code == 10000000){
                        let list = [];
                        if (res.data.mainList.length != 0) {
                            list.push({
                                subCategoryName: '主合同',
                                subName:'主合同'
                            })
                            list.push(...res.data.mainList)
                        }
                        if (res.data.appendList.length != 0) {
                            list.push({
                                subCategoryName: '补充合同',
                                subName:'补充合同'
                            })
                            list.push(...res.data.appendList)
                        }
                        if (res.data.middleList.length != 0) {
                            list.push({
                                subCategoryName: '事中成本',
                                subName:'事中成本'
                            })
                            list.push(...res.data.middleList)
                        }
                        list.push({
                            subCategoryName: '合计',
                            unitSumPrice: res.data.unitSumPrice
                        })
                        this.engineerList = list;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //重置数据
            reset(){
                this.dataForm = {
                    partyBId:'',
                    projectId:'',
                    pageIndex: 1,
                    pageSize: 10,
                };
                this.engineerList = [];
                this.subInfoList = [];
                // this.query();
            },
            exportBtn(){
                let params = {
                    ...this.dataForm,
                }
                projectSettleExportService(params).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //合并表格条件
            spanArrayMethod({row,column,rowIndex,columnIndex}) {
                if (row.subName == '主合同' || row.subName == '补充合同' || row.subName == '事中成本') {
                    if (columnIndex === 0) {
                        return [0, 0];
                    } else if (columnIndex === 1) {
                        return [1, 2];
                    } else if (columnIndex === 2){
                        return [1, 6];
                    }else {
                        return [0, 0];
                    }
                }else if(row.subCategoryName == '合计') {
                    if (columnIndex === 0) {
                        return [0, 0];
                    } else if (columnIndex === 1) {
                        return [1, 6];
                    } else if(columnIndex === 6) {
                        return [1, 1];
                    } else if(columnIndex === 7) {
                        return [1, 1];
                    }else {
                        return [0, 0];
                    }
                }
            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                console.log(columns, data)
            },


            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.query();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.query();
            },

        }
    }
</script>


<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .projectSheet {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
    }
    /deep/.el-table__row td .cell{
        min-height: 20px;
    }
</style>
